import { Container } from "reactstrap";
import styles from "./styles.module.scss";

export const SimpleContent = ({
  customClass = "",
  content,
  buttonTitle1,
  buttonTitleLink1,
  fullWidth = false,
}) => {
  return (
    <>
      {content ? (
        <section
          className={`${styles.root} ${customClass} ${
            fullWidth ? styles.fullWidth : ""
          }`}
        >
          <Container fluid={fullWidth} className={fullWidth ? "px-0" : ""}>
            {content ? (
              <div
                className="mainContent"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            ) : (
              ""
            )}
            {buttonTitleLink1 ? (
              <div>
                <a href={`${buttonTitleLink1}`} className="primaryBtn no-arrow">
                  {buttonTitle1}
                </a>
              </div>
            ) : null}
          </Container>
        </section>
      ) : (
        ""
      )}
    </>
  );
};

export default SimpleContent;
